// Used in view-composite-assignment.component.ts, workspace-details.component.ts, assignment-overview-page.component.ts, reports-scores-student.component.ts, reports-scores.component.ts

import { Injectable } from "@angular/core";

@Injectable()
export class DurationFormat {
    constructor() {}

    // accepts seconds, outputs HH's and MM's
    formatDuration(duration: number) {
        let returnedString,
            minutes,
            hours,
            diff,
            minuteString = " minute",
            hourString = " hour";
        if (duration > 0 && duration < 60) {
            // If duration is 1-59 seconds, display as 1 minute
            returnedString = "1" + minuteString;
        } else {
            minutes = Math.round(duration / 60);
            if (minutes === 1) {
                returnedString = minutes + minuteString;
            } else if (minutes > 1) {
                hours = minutes >= 60 ? Math.floor(minutes / 60) : 0;
                diff = minutes % 60;
                hourString = hours > 1 ? " hours" : hourString;
                minuteString = diff > 1 ? " minutes" : minuteString;
                if (hours) {
                    returnedString =
                        hours + hourString + " and " + diff + minuteString;
                } else {
                    returnedString = minutes + " minutes";
                }
            }
        }
        return returnedString || "";
    }
    //
}
